import { render, staticRenderFns } from "./WalletModal.vue?vue&type=template&id=15c97d00&scoped=true&"
import script from "./WalletModal.vue?vue&type=script&lang=js&"
export * from "./WalletModal.vue?vue&type=script&lang=js&"
import style0 from "./WalletModal.vue?vue&type=style&index=0&id=15c97d00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15c97d00",
  null
  
)

export default component.exports